'use strict';

import React from 'react';

require('styles//Header.css');
// let laborteamLogo = require('../images/laborteam.svg');
import MenuComponent from './MenuComponent.js'
import { Link } from 'react-router-dom'

class HeaderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.resetAnimation = this.resetAnimation.bind(this);
  }

  render() {
    return (
      <div className="header-component" style={this.headerStyle()}>
        <div className="background-container">
          <div className="background" style={this.backgroundStyle()}></div>
          <div className="background-details">
            <img src="/static/images/ligacoes.svg" style={this.detailsStyle()}></img>
          </div>

        </div>
        <Link to="/"><img className="header-logo" alt="Labor Team" src='/static/images/laborteam.svg' style={this.logoStyle()}></img></Link>
        <MenuComponent />
        <p className="subtitle" style={this.subtitleStyle()}>Soluções de Software | Assistência Técnica | Gestão</p>
      </div>
    );
  }

  componentDidMount() {
    this.setState({
      scrollTop: 0
    });
    window.addEventListener('scroll', this.handleScroll);
    // onhashchange = this.resetAnimation;
    // window.addEventListener('hashchange', () => console.log('hashchange1', window.location.hash ));
    // window.addEventListener('hashchange', this.resetAnimation);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('hashchange', this.resetAnimation);
  }

  backgroundStyle() {
    if (this.state && location.pathname != '/') {
      let bottom = (this.state.scrollTop - 880);
      if (bottom > 0) {
        bottom = 0;
      }
      return {
        bottom: bottom + 'px'
      }
    }
  }

  detailsStyle() {
    if (this.state) {
      if (location.pathname != '/') {
        return {
          opacity: 0
        }
      }
    }
    return {};
  }

  headerStyle() {
    if (this.state) {
      let headerHeight = 800,
          zIndex = 1;
      if (this.state.scrollTop * 1.25 < headerHeight - 80) {
        headerHeight = 800 - (this.state.scrollTop * 1.25);
      } else {
        headerHeight = 80;
      }
      if (headerHeight < 400) {
        zIndex = 2;
      }
      if (location.pathname != '/') {
        headerHeight = 80;
        zIndex = 2;
      }
      return {
        height: headerHeight + 'px',
        zIndex: zIndex,
        transition: this.state.ignoreTransition ? 'none' : ''
      };
    }
  }

  logoStyle() {
    if (this.state) {
      let left = 50 - (this.state.scrollTop * 1.5)/16;
      let scale = (680 - this.state.scrollTop * 1.5)/800;

      if (location.pathname == '/') {
        // let margin = 0;
        scale = scale > .2 ? scale : 0.2;
        if (left < 2.5) {
          left = 2.5
        }
      } else {
        left = 2.5;
        scale = 0.2;
      }
      return {
        left: left + '%',
        transform: 'translate(-' + left + '% , -50%)',
        height: (scale * 250) + 'px',
        transition: this.state.ignoreTransition ? 'none' : ''
      };
    }
  }

  subtitleStyle() {
    if (this.state) {
      let scale = (800 - this.state.scrollTop * 1.5)/800;
      scale = scale > 0 ? scale : 0;
      if (location.pathname != '/') {
        scale = 0;
      }
      return {
        transform: 'translate(-50%, 100%) scale(' + scale + ')'
      }
    }
  }

  handleScroll() {
    this.setState({
      scrollTop: window.scrollY? window.scrollY : document.documentElement.scrollTop,
      ignoreTransition: true
    });
  }

  resetAnimation() {
    //console.log('hash change');
    this.setState({
      ignoreTransition: false
    });
  }
}

HeaderComponent.displayName = 'HeaderComponent';

// Uncomment properties you need
// HeaderComponent.propTypes = {};
// HeaderComponent.defaultProps = {};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.js